// Importamos las funciones necesarias desde React.
import { createContext, useContext, useState } from "react";
// Import Functions
import { addInvalid, toNumeric } from "./../functions/generalFunctions";

// Creamos un contexto llamado CalculatorContext con un valor inicial indefinido.
const CalculatorContext = createContext(undefined);

export const CURRENCY = {
    USD: 'USD',
    EUR: 'EUR'
}

// Definimos el proveedor del contexto CalculatorContext.
export const CalculatorContextProvider = ({ children }) => {
    // useState para mostrar el Modal Form
    const [modalForm, setModalForm] = useState({
        visible: false,
        premiumId: null
    });
    // useState para almacenar el historial
    const [history, setHistory] = useState("");
    // useState para almacenar el ID de la Prima activa
    const [activePremium, setActivePremium] = useState("");
    // useStates para todos los inputs de la calculadora
    const [fob, setFob] = useState('');
    const [flete, setFlete] = useState('');
    const [tax, setTax] = useState('');
    const [subtotal, setSubtotal] = useState(0);
    const [extraExpenses, setExtraExpenses] = useState(0);
    const [extraExpensesCheck, setExtraExpensesCheck] = useState(false);
    const [operationalExpenses, setOperationalExpenses] = useState(0);
    const [operationalExpensesCheck, setOperationalExpensesCheck] = useState(false);
    const [totalInsured, setTotalInsured] = useState(0);
    const [rate, setRate] = useState('');
    const [minPremium, setMinPremium] = useState('');
    const [premium, setPremium] = useState(0);
    const [currency, setCurrency] = useState(CURRENCY.USD)

    // Function to calculate the Premium value
    const getPremiumValue =  () => {
        // Vars
        let invalid = false;
    
        // Validar que el valor Fob y la Tarifa no sean nulos
        if(fob === '' || rate === '') {

            let body = document.querySelector('body');
            let fobField = document.querySelector('#fob_value');
            let rateField = document.querySelector('#rate_value');

            invalid = true;

            // remark the mandatory fields
            addInvalid(body, invalid);
            (fob === '') ?  addInvalid(fobField, true) : addInvalid(fobField, false);
            (rate === '') ?  addInvalid(rateField, true) : addInvalid(rateField, false);
        }

         //Si no es Invalido Comenzamos a calcular la Prima
        if (invalid) return null;

        // Let's clean all the value
        const c_fob = toNumeric(fob);
        const c_flete = toNumeric(flete);
        const c_tax = toNumeric(tax);
        const c_rate = toNumeric(rate);
        const c_minPremium = toNumeric(minPremium);

        //Subtotal = Valor FOB + Flete + tax (Arancel)
        const c_subtotal = c_fob + c_flete + c_tax;

        // Gastos Adicionales (10%) = Subtotal * 0,1
        const c_extraExpenses = (extraExpensesCheck) ? c_subtotal * 0.1 : 0;

        // Gastos Operativos (10%) = Valor FOB * 0,1
        const c_operationalExpenses = (operationalExpensesCheck) ? c_fob * 0.1 : 0;

        // Valor Asegurado Total = Subtotal + Gastos Adicionales (10%) + Gastos Operativos (10%)
        const c_totalInsured = c_subtotal + c_extraExpenses + c_operationalExpenses;

        /* Prima o Costo del Certificado de Seguro =
        Si (Valor Asegurado Total * Tasa) <= Prima Mínima de Venta Entonces la Prima o
            Costo del seguro va a ser igual a la Prima Mínima de Venta.
        Si no, va a ser igual al (Valor Asegurado Total * Tasa).
        */
        const result = (c_totalInsured * c_rate / 100 <= c_minPremium) ? c_minPremium : c_totalInsured * c_rate / 100;

         return {
            subtotal: c_subtotal,
            extraExpenses: c_extraExpenses,
            operationalExpenses: c_operationalExpenses,
            totalInsured: c_totalInsured,
            premium: result
        };
    };

    const setCurrentPremim = (id) => {

        // Update the active premium
        setActivePremium(id);

        history.forEach((el)=>{

            if(el.id === id){
                console.log(el)
                setFob(el.fob);
                setFlete(el.flete);
                setTax(el.tax);
                setSubtotal(el.subtotal);
                setExtraExpenses(el.extraExpenses);
                setExtraExpensesCheck(el.extraExpensesCheck);
                setOperationalExpenses(el.operationalExpenses);
                setOperationalExpensesCheck(el.operationalExpensesCheck);
                setTotalInsured(el.totalInsured);
                setRate(el.rate);
                setMinPremium(el.minPremium);
                setPremium(el.premium)
                setCurrency(el.currency)
            }
        });
    }
  
    return (
        // Configuramos el proveedor del contexto para compartir el valor del estado `total`.
        <CalculatorContext.Provider
             value={{ // Todo lo que estara disponible para los componentes hijos.
                modalForm, setModalForm,
                fob, setFob,
                flete, setFlete,
                tax, setTax,
                subtotal, setSubtotal,
                extraExpenses, setExtraExpenses,
                extraExpensesCheck, setExtraExpensesCheck,
                operationalExpenses, setOperationalExpenses,
                operationalExpensesCheck, setOperationalExpensesCheck,
                totalInsured, setTotalInsured,
                rate, setRate,
                minPremium, setMinPremium,
                premium, setPremium,
                history, setHistory,
                activePremium, setActivePremium, setCurrentPremim,
                currency, setCurrency,
                getPremiumValue
            }}
        >
            {/* Renderizamos los componentes hijos dentro del proveedor */}
            {children}
        </CalculatorContext.Provider>
    );
};

// Creamos un hook personalizado que permite a los componentes acceder al contexto de autenticación.
export const useCalculatorContext = () => useContext(CalculatorContext);
